var _circle, _path, _rect, _path2, _rect2, _rect3, _rect4, _rect5, _path3, _rect6, _rect7, _path4, _rect8, _rect9, _rect10, _rect11, _path5, _path6, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 76,
    viewBox: "0 0 75 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 38.25,
    r: 37.5,
    fill: "#1F7682"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.6703 29.3783C47.6028 26.5258 48.6703 22.8503 48.6703 20.1055C48.6703 18.1425 45.4857 18.271 44.4658 20.7361C42.5342 25.4046 44.3686 27.7504 43.5352 30.6489C43.4392 30.9827 43.3666 31.3257 43.3666 31.673V44.0421C43.3666 45.5876 42.116 46.8404 40.5705 46.8404H26.6852C24.1473 46.8404 29.3779 50.1099 30.7285 50.9292C30.932 51.0526 31.1504 51.1461 31.3784 51.2146C32.3601 51.5095 35.2258 52.4099 36.9956 53.3762C44.309 57.369 39.3566 69.5942 47.8131 70.6236C54.0917 71.3879 58.9308 68.5811 62.0596 63.5763C67.0943 55.5227 50.3058 51.9715 49.6093 42.731C49.3234 38.9391 52.8383 36.6638 51.1196 33.1987C49.8133 30.5652 49.7214 32.187 48.6703 29.3783Z",
    fill: "#F9D6BF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5.68421,
    height: 13.9919,
    rx: 2.79838,
    transform: "matrix(0.696114 -0.717931 0.717933 0.696113 16 16.8184)",
    fill: "#F9D6BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7685 47.0227C47.1866 42.9384 42.7217 31.1808 47.8772 32.9228C49.5808 33.4985 51.3134 36.1841 50.6831 37.5269C47.5766 44.1454 48.0942 45.0141 51.8856 49.4207C54.6916 52.6821 58.5787 53.9321 60.7043 58.2452C63.2096 63.329 49.0796 72.5372 45.2716 67.0698C42.2699 62.7602 42.9666 56.3269 38.7578 53.4493C37.8024 52.7961 37.8478 50.4332 38.3571 49.4207C39.6598 46.831 41.9564 49.1879 43.7685 47.0227Z",
    fill: "#FFD2B5",
    fillOpacity: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.3432,
    y: 4.09128,
    width: 28.3213,
    height: 62.1251,
    rx: 3.30751,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.3432,
    y: 4.09128,
    width: 28.3213,
    height: 62.1251,
    rx: 3.30751,
    stroke: "black",
    strokeWidth: 0.686465
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9414,
    y: 6.19238,
    width: 7.30149,
    height: 1.21692,
    rx: 0.608458,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 29.748,
    y: 63.8115,
    width: 11.6699,
    height: 0.686466,
    rx: 0.343233,
    fill: "#E1E1E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.672 32.788C24.816 32.788 24.176 32.184 24.176 31.348C24.176 30.512 24.816 29.908 25.676 29.908C26.132 29.908 26.524 30.072 26.784 30.376L26.448 30.692C26.244 30.472 25.992 30.364 25.7 30.364C25.12 30.364 24.7 30.772 24.7 31.348C24.7 31.924 25.12 32.332 25.7 32.332C25.992 32.332 26.244 32.224 26.448 32L26.784 32.32C26.524 32.624 26.132 32.788 25.672 32.788ZM28.4463 30.588C28.9583 30.588 29.3383 30.88 29.3383 31.524V32.748H28.8383V31.588C28.8383 31.208 28.6503 31.024 28.3303 31.024C27.9743 31.024 27.7343 31.24 27.7343 31.668V32.748H27.2343V29.78H27.7343V30.86C27.8983 30.684 28.1503 30.588 28.4463 30.588ZM32.0001 31.692C32.0001 31.732 31.9961 31.792 31.9921 31.84H30.3161C30.3761 32.152 30.6361 32.352 31.0081 32.352C31.2481 32.352 31.4361 32.276 31.5881 32.12L31.8561 32.428C31.6641 32.656 31.3641 32.776 30.9961 32.776C30.2801 32.776 29.8161 32.316 29.8161 31.68C29.8161 31.044 30.2841 30.588 30.9201 30.588C31.5441 30.588 32.0001 31.024 32.0001 31.692ZM30.9201 30.988C30.5961 30.988 30.3601 31.196 30.3121 31.508H31.5241C31.4841 31.2 31.2481 30.988 30.9201 30.988ZM33.4603 32.776C32.7843 32.776 32.3043 32.32 32.3043 31.68C32.3043 31.04 32.7843 30.588 33.4603 30.588C33.8763 30.588 34.2083 30.76 34.3723 31.084L33.9883 31.308C33.8603 31.104 33.6683 31.012 33.4563 31.012C33.0883 31.012 32.8083 31.268 32.8083 31.68C32.8083 32.096 33.0883 32.348 33.4563 32.348C33.6683 32.348 33.8603 32.256 33.9883 32.052L34.3723 32.276C34.2083 32.596 33.8763 32.776 33.4603 32.776ZM36.397 32.748L35.657 31.832L35.285 32.184V32.748H34.785V29.78H35.285V31.572L36.321 30.612H36.921L36.029 31.508L37.005 32.748H36.397ZM39.2462 31.692C39.2462 31.732 39.2422 31.792 39.2382 31.84H37.5622C37.6222 32.152 37.8822 32.352 38.2542 32.352C38.4942 32.352 38.6822 32.276 38.8342 32.12L39.1022 32.428C38.9102 32.656 38.6102 32.776 38.2422 32.776C37.5262 32.776 37.0622 32.316 37.0622 31.68C37.0622 31.044 37.5302 30.588 38.1662 30.588C38.7902 30.588 39.2462 31.024 39.2462 31.692ZM38.1662 30.988C37.8422 30.988 37.6062 31.196 37.5582 31.508H38.7702C38.7302 31.2 38.4942 30.988 38.1662 30.988ZM41.3184 29.78H41.8184V32.748H41.3384V32.472C41.1704 32.676 40.9224 32.776 40.6304 32.776C40.0104 32.776 39.5504 32.344 39.5504 31.68C39.5504 31.016 40.0104 30.588 40.6304 30.588C40.9064 30.588 41.1504 30.68 41.3184 30.876V29.78ZM40.6904 32.348C41.0504 32.348 41.3264 32.088 41.3264 31.68C41.3264 31.272 41.0504 31.012 40.6904 31.012C40.3304 31.012 40.0544 31.272 40.0544 31.68C40.0544 32.088 40.3304 32.348 40.6904 32.348ZM42.3645 31.844V31.428H43.4645V31.844H42.3645ZM44.0596 32.748V29.948H44.5796V32.748H44.0596ZM46.5009 30.588C47.0129 30.588 47.3929 30.88 47.3929 31.524V32.748H46.8929V31.588C46.8929 31.208 46.7049 31.024 46.3849 31.024C46.0289 31.024 45.7889 31.24 45.7889 31.668V32.748H45.2889V30.612H45.7649V30.888C45.9289 30.692 46.1889 30.588 46.5009 30.588Z",
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 5.68421,
    height: 10.3736,
    rx: 2.79838,
    transform: "matrix(0.642788 -0.766044 0.766045 0.642787 17.2617 52.4121)",
    fill: "#F9D6BF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 3.37942,
    height: 4.41834,
    rx: 1.68971,
    transform: "matrix(0.642788 -0.766044 0.766045 0.642787 21.7812 43.3916)",
    fill: "#FFE2CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8499 43.4012C23.4206 43.6811 22.6832 44.1331 22.5588 43.6359C22.4413 43.1665 22.5525 42.4607 23.0283 41.9928C23.4728 41.5557 23.8592 41.4073 24.5539 41.5233C25.2581 41.6408 24.5059 42.9733 23.8499 43.4012Z",
    fill: "#FFE7D7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 5.68421,
    height: 9.75228,
    rx: 2.79838,
    transform: "matrix(0.642788 -0.766044 0.766045 0.642787 17.5195 46.0098)",
    fill: "#F9D6BF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 5.68421,
    height: 11.099,
    rx: 2.79838,
    transform: "matrix(0.642788 -0.766044 0.766045 0.642787 17 39.1035)",
    fill: "#F9D6BF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 3.37942,
    height: 4.41834,
    rx: 1.68971,
    transform: "matrix(0.642788 -0.766044 0.766045 0.642787 21 47.3379)",
    fill: "#FFE2CE"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 3.37942,
    height: 4.41834,
    rx: 1.68971,
    transform: "matrix(0.642788 -0.766044 0.766045 0.642787 22 41.3379)",
    fill: "#FFE2CE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3342 48.6639C23.905 48.9438 23.1676 49.3957 23.0432 48.8986C22.9257 48.4292 23.0368 47.7234 23.5127 47.2555C23.9572 46.8184 24.3436 46.67 25.0383 46.786C25.7425 46.9035 24.9903 48.236 24.3342 48.6639Z",
    fill: "#FFE7D7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3342 42.6639C24.905 42.9438 24.1676 43.3957 24.0432 42.8986C23.9257 42.4292 24.0368 41.7234 24.5127 41.2555C24.9572 40.8184 25.3436 40.67 26.0383 40.7859C26.7425 40.9034 25.9903 42.236 25.3342 42.6639Z",
    fill: "#FFE7D7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_654_1582)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 19.248C30 17.5241 30.6848 15.8708 31.9038 14.6519C33.1228 13.4329 34.7761 12.748 36.5 12.748C38.2239 12.748 39.8772 13.4329 41.0962 14.6519C42.3152 15.8708 43 17.5241 43 19.248C43 20.972 42.3152 22.6253 41.0962 23.8442C39.8772 25.0632 38.2239 25.748 36.5 25.748C34.7761 25.748 33.1228 25.0632 31.9038 23.8442C30.6848 22.6253 30 20.972 30 19.248ZM36.1291 22.03L39.8713 17.3518L39.1953 16.811L36.0043 20.7985L33.744 18.9152L33.1893 19.5808L36.1291 22.0309V22.03Z",
    fill: "#26BC00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_654_1582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(30 12.748)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckin);
export default __webpack_public_path__ + "static/media/checkin.96d7f03cf71fc3e588f5e1d9a7f1ca7f.svg";
export { ForwardRef as ReactComponent };